import React, { useCallback } from 'react';
import { createToast, Toast, ToastButton } from 'components/core';
import { CustomFieldCategory, CustomFieldSupportedSuggestion } from 'types';

export const scrollToSection = (id: string): void => {
  const anchor = document.getElementById(id);
  if (anchor) {
    const stickyHeaderOffset = 100;
    window.scrollTo({
      top: anchor.offsetTop - stickyHeaderOffset,
      behavior: 'smooth',
    });
  }
};

export const showErrors = (
  errorMessages: string[],
  showHelp = true,
  restoreFocusTo?: HTMLElement | null
): void => {
  errorMessages.forEach((message) => {
    createToast(
      <Toast
        type="danger"
        focusOnAppear={showHelp}
        restoreFocusTo={restoreFocusTo}
      >
        {message}
        {showHelp && (
          <ToastButton
            to={'mailto:support@covidence.org'}
            target="blank"
            rel="noopener noreferrer"
          >
            Need help?
          </ToastButton>
        )}
      </Toast>,
      { duration: 6000 }
    );
  });
};

const suggestionsForAdditionalField = (
  fieldName: string,
  supportedSuggestions: CustomFieldSupportedSuggestion[],
  category: CustomFieldCategory
) => {
  const potential = supportedSuggestions
    .filter((item) => item.categories.includes(category))
    .find((item) => {
      return item.aliases.some((alias) => {
        return (
          alias.toLowerCase() ===
          fieldName.trim().replaceAll(/\s+/g, ' ').toLowerCase().trim()
        );
      });
    });

  return !!potential?.field;
};

export const useCheckSuggestions = (
  supportedSuggestions: CustomFieldSupportedSuggestion[],
  category: CustomFieldCategory
) => {
  return useCallback(
    (fieldName: string) => {
      return suggestionsForAdditionalField(
        fieldName,
        supportedSuggestions,
        category
      );
    },
    [supportedSuggestions, category]
  );
};
